/**
 * Announces a message to screen readers via ARIA live region
 * @param {string} message - The message to announce
 * @param {number} clearDelay - Time in ms before clearing the message (default: 3000)
 */
export function announceToScreenReader(message, clearDelay = 3000) {
    const announcer = document.getElementById('sr-announcements');

    if (!announcer) {
        console.warn('Screen reader announcements element not found');
        return;
    }

    // Clear previous announcement
    announcer.textContent = '';

    // Small delay to ensure screen reader picks up the change
    setTimeout(() => {
        announcer.textContent = message;

        // Clear after delay to allow for new announcements
        if (clearDelay > 0) {
            setTimeout(() => {
                announcer.textContent = '';
            }, clearDelay);
        }
    }, 100);
}

/**
 * Announces an urgent message to screen readers (aria-live="assertive")
 * @param {string} message - The urgent message to announce
 * @param {number} clearDelay - Time in ms before clearing the message (default: 3000)
 */
export function announceUrgentToScreenReader(message, clearDelay = 3000) {
    const announcer = document.getElementById('sr-announcements');

    if (!announcer) {
        console.warn('Screen reader announcements element not found');
        return;
    }

    // Temporarily change to assertive mode for urgent messages
    const originalMode = announcer.getAttribute('aria-live');
    announcer.setAttribute('aria-live', 'assertive');

    announcer.textContent = '';

    setTimeout(() => {
        announcer.textContent = message;

        if (clearDelay > 0) {
            setTimeout(() => {
                announcer.textContent = '';
                // Restore original mode
                announcer.setAttribute('aria-live', originalMode);
            }, clearDelay);
        }
    }, 100);
}
